export type DeskWidgetId = "next-action" | "pending" | "recommendations" | "stock";

export type DeskPreferences = {
  order: DeskWidgetId[];
  hidden: DeskWidgetId[];
};

export const DESK_WIDGET_IDS: DeskWidgetId[] = ["next-action", "pending", "recommendations", "stock"];

export const DEFAULT_DESK_PREFERENCES: DeskPreferences = {
  order: [...DESK_WIDGET_IDS],
  hidden: [],
};

export function normalizeDeskPreferences(value: Partial<DeskPreferences> | null | undefined): DeskPreferences {
  const rawOrder = Array.isArray(value?.order) ? value.order : [];
  const validOrder = rawOrder.filter((id): id is DeskWidgetId => DESK_WIDGET_IDS.includes(id as DeskWidgetId));
  const order = [...Array.from(new Set(validOrder)), ...DESK_WIDGET_IDS.filter((id) => !validOrder.includes(id))];
  const hidden = Array.isArray(value?.hidden)
    ? Array.from(new Set(value.hidden.filter((id): id is DeskWidgetId => DESK_WIDGET_IDS.includes(id as DeskWidgetId))))
    : [];
  return { order, hidden };
}

export function moveDeskWidget(order: DeskWidgetId[], widgetId: DeskWidgetId, direction: "up" | "down") {
  const current = order.indexOf(widgetId);
  const target = direction === "up" ? current - 1 : current + 1;
  if (current < 0 || target < 0 || target >= order.length) return order;
  const next = [...order];
  [next[current], next[target]] = [next[target], next[current]];
  return next;
}
